import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Champ de formulaire de la maquette : libellé en petites majuscules au-dessus
 * d'un cadre blanc.
 *
 * Le libellé est un `<label>` qui englobe le contenu projeté, sans attribut
 * `for` : l'association au champ est alors garantie par l'imbrication, sans
 * identifiant à générer ni à synchroniser. Une association cassée est le défaut
 * d'accessibilité le plus courant sur les formulaires, autant la rendre
 * impossible par construction.
 */
@Component({
  selector: 'ct-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <label>
      <span class="ct-label">{{ label() }}</span>
      <span class="ct-field-box">
        <ng-content />
      </span>
    </label>
    @if (hint(); as text) {
      <p class="hint ct-muted">{{ text }}</p>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    label {
      display: block;
    }

    .hint {
      font-size: var(--ct-size-xs);
      margin: var(--ct-space-1) 0 0;
    }
  `,
})
export class CtField {
  readonly label = input.required<string>();

  /** Précision sous le champ : une unité, une contrainte de saisie. */
  readonly hint = input<string | undefined>(undefined);
}
